export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const APP_BASE_URL = process.env.REACT_APP_BASE_URL || '';
export const APP_IDP_URL = process.env.REACT_APP_IDP_URL || '';
export const APP_IDP_CLIENTID = process.env.REACT_APP_IDP_CLIENTID || '';
